import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import { ImportInvoicedApplicants } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ImportInvoiceApplicantService {

  constructor( private http: HttpClient,
    private apiService: ApiService) { }

    public importInvoice(importInvoice:ImportInvoicedApplicants):Observable<any> {
      return this.apiService.post(`ImportInvoicedApplicant/ProcessImport`, importInvoice)
  }
  public checkImportApplicants(importInvoice:ImportInvoicedApplicants):Observable<any> {
    return this.apiService.post(`ImportInvoicedApplicant/CheckImportApplicants`, importInvoice)
}
}
